module.exports = __webpack_public_path__ + "static/media/Mereoleona.a786ca60.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona.woff2
// module id = 2270
// module chunks = 50